export default "__VITE_ASSET__CmA7GrnR__"